import type { ReactNode } from 'react';

export const symbol_splitscreen_vertical_add: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M780-780H620h4-32 188Zm-248 0q0-24 18-42t42-18h188q24 0 42 18t18 42v410q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-410H592v660q-24 0-42-18t-18-42v-600ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h187q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm187-660H180v600h187v-600Zm0 0H180h187Zm413 660h-50q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h50v-50q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v50h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-50v50q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q780-57.25 780-70v-50Z"
		/>
	</svg>
);
